import { useState, useEffect } from 'react';

/**
 * Custom hook for responsive media queries
 * @param {string} query - CSS media query (e.g., '(max-width: 1024px)')
 * @returns {boolean} - True if query matches
 */
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    
    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);
    
    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
};